import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/agenda/items`;

const withQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, String(value));
  });
  const qs = search.toString();
  return qs ? `${BASE}?${qs}` : BASE;
};

export const userAgendaAPI = {
  async list(params = {}) {
    return apiClient(withQuery(params));
  },

  async getById(id) {
    return apiClient(`${BASE}/${id}`);
  },

  async create(data) {
    return apiClient(BASE, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id, data) {
    return apiClient(`${BASE}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async markDone(id, is_done = true) {
    return apiClient(`${BASE}/${id}/done`, {
      method: 'PATCH',
      body: JSON.stringify({ is_done }),
    });
  },

  async updateStatus(id, status) {
    return apiClient(`${BASE}/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    });
  },

  async remove(id) {
    return apiClient(`${BASE}/${id}`, { method: 'DELETE' });
  },
};

export default userAgendaAPI;
